import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WizardProgress.css';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
}

const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep, totalSteps }) => {
  const navigate = useNavigate();

  const steps = [
    { number: 1, title: 'Projekt', path: '/wizard/project' },
    { number: 2, title: 'PDF-Formular', path: '/wizard/template' },
    { number: 3, title: 'Datenvorlagen', path: '/wizard/datasources' },
    { number: 4, title: 'Beziehungen', path: '/wizard/relationships' },
    { number: 5, title: 'Feldzuordnung', path: '/wizard/mapping' },
  ];

  return (
    <div className="wizard-progress">
      <div className="progress-steps">
        {steps.map((step) => (
          <div
            key={step.number}
            className={`progress-step ${
              step.number === currentStep
                ? 'active'
                : step.number < currentStep
                ? 'completed'
                : ''
            }`}
            onClick={() => step.number < currentStep && navigate(step.path)}
          >
            <div className="step-number">
              {step.number < currentStep ? '✓' : step.number}
            </div>
            <div className="step-title">{step.title}</div>
          </div>
        ))}
      </div>
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default WizardProgress;
